var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowDownDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "8px",
    viewBox: "0 0 15 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 1.25e-05 13.8405 1.25e-05 13.8405 7.7498875 0 7.7498875"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "product-details",
    transform: "translate(-1266.000000, -1649.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-2",
    transform: "translate(1274.000000, 1653.000000) rotate(-270.000000) translate(-1274.000000, -1653.000000) translate(1259.000000, 1638.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.625000, 15.000000) rotate(-90.000000) translate(-15.625000, -15.000000) translate(8.125000, 10.625000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8405,0.8748875 C13.8405,1.0998875 13.753,1.3248875 13.5905,1.4998875 L8.1655,6.9373875 L7.628,7.4623875 C7.4405,7.6373875 7.1905,7.7498875 6.9155,7.7498875 C6.678,7.7498875 6.453,7.6623875 6.278,7.5248875 L0.253,1.4998875 C-0.0845,1.1498875 -0.0845,0.5998875 0.253,0.2623875 C0.5905,-0.0876125 1.153,-0.0876125 1.4905,0.2623875 L6.928,5.6998875 L12.353,0.2623875 C12.6905,-0.0876125 13.2405,-0.0876125 13.5905,0.2623875 C13.753,0.4248875 13.8405,0.6498875 13.8405,0.8748875",
    id: "Fill-1",
    fill: "#3C4042",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDownDark);
export default __webpack_public_path__ + "static/media/ic_arrow_down_dark.2979e2a3.svg";
export { ForwardRef as ReactComponent };